<template>
  <span>{{ formatted }}</span>
</template>

<script>
export default {
  name: 'AnimatedNumber',
  props: {
    value: {type: Number, default: 0},
    decimals: {type: Number, default: 0},
    duration: {type: Number, default: 1200},
    prefix: {type: String, default: ''},
    suffix: {type: String, default: ''},
    locale: {type: String, default: 'de-DE'}
  },
  data() {
    return {
      displayed: 0
    }
  },
  computed: {
    formatted() {
      const formatted = new Intl.NumberFormat(this.locale, {
        minimumFractionDigits: this.decimals,
        maximumFractionDigits: this.decimals
      }).format(this.displayed);
      return `${this.prefix}${formatted}${this.suffix}`;
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.animate(oldVal || 0, newVal || 0);
    }
  },
  mounted() {
    this.animate(0, this.value || 0);
  },
  beforeDestroy() {
    if (this.frame) cancelAnimationFrame(this.frame);
  },
  methods: {
    animate(from, to) {
      if (this.frame) cancelAnimationFrame(this.frame);
      const start = performance.now();
      const duration = this.duration;

      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        this.displayed = from + (to - from) * eased;

        if (progress < 1) {
          this.frame = requestAnimationFrame(step);
        } else {
          this.displayed = to;
        }
      };

      this.frame = requestAnimationFrame(step);
    }
  }
}
</script>
